/**
 * Constantes pour les composants de la page d'accueil
 * @module home/constants
 */

/**
 * Styles de boutons pour les cartes d'applications
 * @type {Object}
 */
export const APP_BUTTON_STYLES = {
  TWITCH: {
    background: 'linear-gradient(135deg, #9147ff 0%, #772ce8 100%)',
    color: '#fff',
  },
  SPOTIFY: {
    background: 'linear-gradient(135deg, #1db954 0%, #1ed760 100%)',
    color: '#fff',
  },
};

/**
 * Textes et labels pour les composants
 * @type {Object}
 */
export const HOME_TEXTS = {
  SKIP_TO_MAIN: 'Aller au contenu principal',
  SKIP_TO_DASHBOARD: 'Aller au tableau de bord',
  NAV_DASHBOARD: 'Tableau de bord',
  HERO_OPEN_DASHBOARD: 'Ouvrir le tableau de bord',
  CONNECTED: 'Connecté',
  DISCONNECTED: 'Non connecté',
  DISCONNECT_HINT: 'Connectez-vous pour commencer',
  LOGOUT: 'Déconnexion',
  LOGOUT_TITLE: 'Se déconnecter',
  TWITCH_APP: {
    TITLE: 'Application Twitch',
    DESCRIPTION:
      "Créez votre application Twitch pour permettre à d'autres utilisateurs d'utiliser le bot sur leur chaîne.",
    BUTTON: 'Créer une app Twitch',
  },
  SPOTIFY_APP: {
    TITLE: 'Application Spotify',
    DESCRIPTION:
      "Créez votre application Spotify pour permettre à n'importe qui de contrôler la musique sur votre stream.",
    BUTTON: 'Créer une app Spotify',
  },
  APPS_SECTION: {
    TITLE: 'Vos Applications',
    SUBTITLE:
      'Gérez vos connexions Twitch et Spotify pour contrôler votre stream',
    DASHBOARD_TITLE: 'Accéder au Dashboard',
  },
  FOOTER: {
    TEXT: 'Propulsé par Twitch & Spotify APIs',
    RIGHTS: 'Tous droits réservés',
    MENTIONS_LEGALES: 'Mentions légales',
  },
};

/**
 * Paramètres d'URL pour la gestion de la connexion
 * @type {Object}
 */
export const URL_PARAMS = {
  LOGIN: 'login',
  NEXT: 'next',
  LOGIN_VALUE: '1',
};
